import { ActionIcon, Tooltip } from '@mantine/core';
import type { ReactNode } from 'react';

import { IS_APPLE, MOD_KEY, ShortcutHint } from '@/shared/shortcut-hint';

type MediaToggleProps = {
    enabled: boolean;
    enabledIcon: ReactNode;
    disabledIcon: ReactNode;
    turnOffLabel: string;
    turnOnLabel: string;
    shortcutKey: string;
    onToggle: () => void;
};

export function MediaToggle({
    enabled,
    enabledIcon,
    disabledIcon,
    turnOffLabel,
    turnOnLabel,
    shortcutKey,
    onToggle,
}: Readonly<MediaToggleProps>) {
    const label = enabled ? turnOffLabel : turnOnLabel;

    return (
        <Tooltip label={<ShortcutHint keys={[[MOD_KEY, shortcutKey]]} label={label} />}>
            <ActionIcon
                aria-keyshortcuts={`${IS_APPLE ? 'Meta' : 'Control'}+${shortcutKey}`}
                aria-label={label}
                aria-pressed={enabled}
                color={enabled ? undefined : 'danger'}
                radius="var(--radius-rounded-full)"
                size="lg"
                variant={enabled ? 'default' : 'filled'}
                onClick={onToggle}
            >
                {enabled ? enabledIcon : disabledIcon}
            </ActionIcon>
        </Tooltip>
    );
}
